<dialog
  #dialog
  [class]="'modal-dialog modal-dialog--' + variant()"
  [attr.aria-labelledby]="headline() ? 'modalDialogTitle' : null"
  (cancel)="onCancel($event)">
  <header class="modal-dialog__header">
    <div class="modal-dialog__header__left">
      @if (headlineDescription()) {
        <div class="modal-dialog__header__description">{{ headlineDescription() }}</div>
      }
      @if (headline()) {
        <h2 class="modal-dialog__header__headline" id="modalDialogTitle">{{ headline() }}</h2>
      }
    </div>
    <button
      class="modal-dialog__header__close-button"
      [attr.aria-label]="'a11y.button.close_dialog' | translate"
      title="{{ 'a11y.button.close_dialog' | translate }}"
      (click)="onCloseClick()">
      <ebeihilfe-cross-svg />
    </button>
  </header>
  <div class="modal-dialog__content">
    <ng-content />
  </div>
</dialog>
